import { CircularProgress, Typography } from "@mui/material";
import lodash from "lodash";
import { useContext, useEffect, useRef, useState, useMemo } from "react";
import { toast, ToastContainer } from "react-toastify";
import api from "../../BrandOnBoarding/api";
import Modal from "../../Component/Modal/Modal";
import MUIAutocomplete from "../../Component/UI/MUIAutocomplete/MUIAutocomplete";
import MUIButton from "../../Component/UI/MUIButton/MUIButton";
import MUISelect from "../../Component/UI/MUISelect/MUISelect";
import RadioGroup from "../../Component/UI/RadioGroup/RadioGroup";
import Warning from "../../Component/Warning/Warning";
import { LLM_OPTIONS } from "../../utils/constant";
import { validateBrandInputValue, validateProductInputValue } from "../../utils/helpers";
import { getCategoryPrompt } from "../../utils/prompt";
import Suggestions from "../CategoryDiscovery/Suggestions/Suggestions";
import TextInput from "../../Component/UI/TextInput/TextInput";
import AttributeInput from "../CategoryDiscovery/AttributeInput/AttributeInputV2";
import classes from "./Form.module.css";
import ProductVariant from "./ProductVariant";
import UserKeyPlayer from "./UserKeyPlayer";
import { DiscoveryContext } from "./discovery-context";
import { ENTITY_LABELS, getEntityLabel } from "../../utils/labelMapping";
import useCountry from "./useCountry";
import useGeneratePreCategoryDimensions from "./useGeneratePreCategoryDimensions";
import useGenerateProductTaxonomies from "./useGenerateProductTaxonomies";
import useProductPreference from "./useProductPreference";
import useTopUserProducts from "./useTopUserProducts";
import { Checkbox, FormControlLabel } from "@mui/material";
import useHistory from "./History/useHistory";
import { getCategoryTypePrompt } from "../../utils/prompts/prompts.en";
import MUIMultiSelect from "../../Component/UI/MUIMultiSelect/MUIMultiSelect";
import { classNames } from "@react-pdf-viewer/core";
import History from "../DiscoveryV2/History/HistoryV2"



export default function Form({
  onSubmit,
  onTypeChanged = () => { },
  onReset = () => { },
  warningText,
  setWarningText = () => { },
  cancelTransaction,
  stopPolling = () => { },
  startPolling = () => { },
  setCancelTransaction = () => { },
  setIsHistoryRefresh = () => { },
  setPage = () => { },
  page,
  isHistoryRefresh = false
}) {
  const discoveryCtx = useContext(DiscoveryContext);
  const [loading, setLoading] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [showManualKeyPlayerInput, setShowManualKeyPlayerInput] =
    useState(false);
  const [productVariants, setProductVariants] = useState([]);
  const competitorsRef = useRef(discoveryCtx.competitors);

  const [brand, setBrand] = useState("");
  // const [discoveryType, setDiscoveryType] = useState(discoveryCtx.type || "brand");
  const [llm, setLLM] = useState("gpt-5.1");
  const [category, setCategory] = useState("");
  const [categoryType, setCategoryType] = useState("");
  const [market, setMarket] = useState("");
  const [selectedBrandsProducts, setSelectedBrandProducts] = useState([]);
  const [prefLoading, setPrefLoading] = useState(false);
  const [showManualCategoryInput, setShowManualCategoryInput] = useState(false);
  const [showManualCategoryTypeInput, setShowManualCategoryTypeInput] = useState(false);
  const [manualCategoryInput, setManualCategoryInput] = useState("");
  const [manualCategoryTypeInput, setManualCategoryTypeInput] = useState("");
  const [aICategories, setAICategories] = useState([]);
  const [aICategoryTypes, setAICategoryTypes] = useState([]);
  const [isMock, setIsMock] = useState(false);
  const [showHistoryModal, setShowHistoryModal] = useState(false)
  const [brandDomain, setBrandDomain] = useState([]);
  const [isCategorySuggestionLoading, setCategorySuggestionLoading] =
    useState(false);
  const [isCategoryTypeSuggestionLoading, setCategoryTypeSuggestionLoading] =
    useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const categoryChangeTimerRef = useRef();
  const keyPlayerChangeTimerRef = useRef();
  const discoveryType = discoveryCtx?.type || "brand"
  const {
    loading: keyPlayersLoading,
    keyPlayers,
    setKeyPlayers,
    getBrandOrProductSuggestions,
  } = useTopUserProducts();
  const {
    deleteHistory,
  } = useHistory(discoveryType);
  const { getProductPrefs } = useProductPreference();
  const { generateProductTaxonomies } = useGenerateProductTaxonomies();
  const { generatePreCategoryDimensions } = useGeneratePreCategoryDimensions();
  const discoveryTransactionId = discoveryCtx.state.id;
  const timerRef = useRef();
  const abortControllerRef = useRef(null);
  const RADIO_OPTIONS = [
    {
      value: "brand",
      label: ENTITY_LABELS.brand,
    },
    {
      value: "product",
      label: ENTITY_LABELS.product,
    },
  ];

  const updatedKeyPlayers = keyPlayers.length > 0
    ? [
      ...keyPlayers.map((player) => ({
        ...player,
        value: player.name,
        name: player.name,
      })),
      {
        name: "Add Manually",
        domain: "",
        value: "addManually",
        id: 0,
      }
    ]
    : [];

  let hasRequiredCompetitors =
    discoveryType === "category"
      ? discoveryCtx.competitors.length > 0
      : discoveryCtx.competitors.length >= 1;

  //       useEffect(()=>{
  // setDiscoveryType(discoveryCtx?.type)
  //       },[discoveryCtx?.type])

  useEffect(() => {
    if (!category || discoveryTransactionId) return;
    if (categoryChangeTimerRef.current) {
      clearTimeout(categoryChangeTimerRef.current);
    }
    discoveryCtx.updateProductPrefs([]);
    categoryChangeTimerRef.current = setTimeout(() => {
      if (discoveryCtx.type === "category" || discoveryCtx.type === "product") {
        generateProductTaxonomies(category, llm);
        setPrefLoading(true);
        if (discoveryCtx.type === "category") {
          getProductPrefs()
            .then(() => setPrefLoading(false))
            .catch(() => setPrefLoading(false));
        }
      }
      // generatePreCategoryDimensions(category);
    }, 1000);
  }, [category, llm, brand]);

  useEffect(() => {
    if (!brand || discoveryCtx.is_launched || discoveryCtx.is_resetFormState) {
      // setAICategories([]);
      return;
    }
    async function getCategoryAISuggestions() {
      setCategorySuggestionLoading(true);
      let language = discoveryCtx.language;
      try {
        const prompt = getCategoryPrompt(brand, language);
        const payload = {
          llm: llm,
          prompt: prompt,
        };

        let response = await api.post(`/llm-execute`, payload);
        const result = response?.data?.data || [];

        if (result) {
          let resultArray = result;
          setAICategories([
            ...resultArray.categories.map((o) => ({ name: o, value: o })),
            {
              name: "Add Manually",
              value: "Add Manually",
            },
          ]);

        }
      } catch (error) {
        console.log(error);
      } finally {
        setCategorySuggestionLoading(false);
      }
    }

    const debouncedFunction = lodash.debounce(getCategoryAISuggestions, 2000);
    debouncedFunction();
    return () => debouncedFunction.cancel();
  }, [brand, discoveryCtx.is_launched, discoveryCtx.language, llm]);

  useEffect(() => {
    if (!brand || discoveryCtx.is_launched || !category || discoveryCtx.is_resetFormState) {
      // setAICategoryTypes([]);
      return;
    }
    async function getCategoryTypeAISuggestions() {
      setCategoryTypeSuggestionLoading(true);
      let language = discoveryCtx.language;
      console.log("language", language);
      try {
        const prompt = getCategoryTypePrompt(brand, category, language);
        const payload = {
          llm: llm,
          prompt: prompt,
        };

        let response = await api.post(`/llm-execute`, payload);
        const result = response?.data?.data || [];

        if (result) {
          let resultArray = result;
          setAICategoryTypes([
            ...resultArray.categoryTypes.map((o) => ({ name: o, value: o })),
            {
              name: "Add Manually",
              value: "Add Manually",
            }
          ]);

        }
      } catch (error) {
        console.log(error);
      } finally {
        setCategoryTypeSuggestionLoading(false);
      }
    }

    const debouncedFunction = lodash.debounce(getCategoryTypeAISuggestions, 2000);
    debouncedFunction();
    return () => debouncedFunction.cancel();
  }, [brand, discoveryCtx.is_launched, category]);

  useEffect(() => {
    if (!category || discoveryTransactionId || !brand || cancelTransaction || discoveryCtx.is_resetFormState) {
      return;
    }
    if (keyPlayerChangeTimerRef.current) {
      clearTimeout(keyPlayerChangeTimerRef.current);
    }
    discoveryCtx.updatedCompetitors(
      discoveryCtx.competitors.filter(
        (comp) =>
          comp &&
          comp?.name.toString().toLowerCase() ===
          discoveryCtx.entity.toString().toLowerCase()
      )
    );
    keyPlayerChangeTimerRef.current = setTimeout(() => {
      if (discoveryCtx.type === "category" || discoveryCtx.type === "product")
        getBrandOrProductSuggestions(
          "product",
          category,
          null,
          [],
          null,
          market,
          brand
        );
      if (discoveryCtx.type === "brand")
        getBrandOrProductSuggestions(
          "brand",
          category,
          null,
          [],
          null,
          market,
          brand
        );
    }, 1000);
  }, [discoveryTransactionId, brand, discoveryType, category, market, llm]);


  function handleProductBrandSelection(players, options) {
    // CASE 1: User added manually
    // So add that object into keyPlayers list
    if (!Array.isArray(players)) {
      const manualObj = players; // your object containing id/name/domain

      setKeyPlayers(prev => {
        const exists = prev.some(p => p.name === manualObj.name);
        if (!exists) {
          return [
            ...prev,
            manualObj
          ];
        }
        return prev;
      });
      if (selectedBrandsProducts?.length >= 5) {
         toast.warn("Only 5 competitors are allowed");
          return;
      }
      // ALSO update selected competitor list
      setSelectedBrandProducts(prev => {
        const exists = prev.some(p => p.name === manualObj.name);
        if (!exists) {
          const updated = [...prev, manualObj];
          discoveryCtx.updatedCompetitors(updated);
          return updated;
        }
        return prev;
      });

      return;
    }

    // CASE 2: Normal selection (players is array)
    const maxProductBrands = 5;
    const message = "Only 5 competitors are allowed";
    setSelectedBrandProducts((prevPlayers) => {
      let updatedPlayers = players.map(player => {
        const match = options.find(item => item.value === player);
        return match ? match : { value: player, name: player, domain: "example.com" };
      });

      if (updatedPlayers.length > maxProductBrands) {
        toast.warn(message);
        updatedPlayers = updatedPlayers.slice(0, maxProductBrands);
        discoveryCtx.updatedCompetitors(updatedPlayers);
        return prevPlayers;
      }

      discoveryCtx.updatedCompetitors(updatedPlayers);
      return updatedPlayers;
    });
  }

  function handleDeleteBrandProduct(itemName) {
    setSelectedBrandProducts((prevBrandProducts) => {
      return prevBrandProducts.filter((item) => item.name != itemName);
    });
    const updatedCompetitors = discoveryCtx.competitors.filter(
      (comp) =>
        comp.name.toString().toLowerCase() !== itemName.toString().toLowerCase()
    );
    discoveryCtx.updatedCompetitors(updatedCompetitors);
  }

  useEffect(() => {
    if (discoveryCtx.abort_launch || !discoveryCtx.is_launched) {
      setSelectedBrandProducts([]);
    }
  }, [discoveryCtx.abort_launch, discoveryCtx.is_launched]);

  useEffect(() => {
    if (selectedBrandsProducts.length > 0) return;
    if (discoveryTransactionId) {
      setKeyPlayers([]);
      return;
    }
    if (keyPlayers.length === 8 && discoveryType !== "category") {
      const updatedCompetitors = [...discoveryCtx.competitors].concat(
        keyPlayers.slice(0, 3)
      );
      discoveryCtx.updatedCompetitors(updatedCompetitors);
      setSelectedBrandProducts([...keyPlayers.slice(0, 3)]);
    }
  }, [
    keyPlayers,
    discoveryType,
    discoveryCtx.category,
    discoveryTransactionId,
  ]);

  useEffect(() => {
    competitorsRef.current = discoveryCtx.competitors;
  }, [discoveryCtx.competitors]);

  async function checkIfInputValid(input) {
    setLoading(true);
    setSuggestions([]);
    setWarningText("");
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    const controller = new AbortController();
    abortControllerRef.current = controller;

    try {
      let response = await validateBrandInputValue(input, controller.signal, category);
      setLoading(false);
      // Only continue if this request wasn’t aborted
      if (controller.signal.aborted) return;
      const domain = response?.data?.data?.domain || "example.com";
      setBrandDomain(domain)
      if (response?.data?.data?.ans !== "Yes") {
        setWarningText(
          `The ${discoveryType} or category name appears to be incorrect. This may impact the ${ENTITY_LABELS.brandIndexScore}.`
        );
        setSuggestions(response?.data?.data?.correct_inputs ?? []);
      }
    } catch (error) {
      console.log("Error while validating input", error);
      setLoading(false);
    }
  }

  async function checkIfProductValid(input) {
    setLoading(true);
    setSuggestions([]);
    setWarningText("");
    setProductVariants([]);
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    const controller = new AbortController();
    abortControllerRef.current = controller;

    try {
      let response = await validateProductInputValue(input, controller.signal, category);
      setLoading(false);
      if (controller.signal.aborted) return;
      const responseData = response?.data;
      const variants = responseData?.data?.variants || [];
      const updatedVariants = variants.map((variant) => {
        return {
          id: variant,
          name: variant,
          active: true,
        };
      });
      setProductVariants(updatedVariants);
      setBrandDomain(responseData.data.domain)

      if (responseData.data.ans !== "Yes") {
        if (
          new String(responseData?.data?.correct_inputs[0])
            .toLocaleLowerCase()
            .trim() !== new String(discoveryCtx.entity).toLowerCase().trim()
        ) {
          setSuggestions(responseData?.data?.correct_inputs);
          setWarningText(
            `The ${discoveryType} or category name appears to be incorrect. This may impact the ${ENTITY_LABELS.brandIndexScore}.`
          );
        }
      }
    } catch (error) {
      console.log("Error while validating input", error);
      setLoading(false);
    }
  }

  function handleSuggestionClick(text) {
    discoveryCtx.updatedCompetitors([]);
    setBrand(text);
    setSuggestions([]);
    setSelectedBrandProducts([]);
  }

  function handleBrandInputChange(e) {
    const value = e.target.value;
    setBrand(value);
    resetState();
    setCategory("");
    setCategoryType("");
  }
  function resetState() {
    discoveryCtx.updateAbortLaunch(true);
    setProductVariants([]);
    discoveryCtx.updateId(null);
    discoveryCtx.updatedLaunched(false);
  }
  function handleDiscoveryTypeChange(value) {
    discoveryCtx.resetState();
    discoveryCtx.updateLanguage("en");
    setPage(1);
    stopPolling();
    onTypeChanged(value);
    discoveryCtx.updateType(value);
    // setDiscoveryType(value);
    setBrand("");
    setCategory("");
    setCategoryType("");
    setAICategories([]);
    setAICategoryTypes([]);
    setLLM("gpt-5.1");
    setSuggestions([]);
    setProductVariants([]);
    setKeyPlayers([]);
    setSelectedBrandProducts([]);
    onReset();
    setMarket("");
  }

  function deleteTransaction() {
    setIsHistoryRefresh(prev => !prev);
    discoveryCtx.resetState();
    stopPolling();
    setCategory("");
    setCategoryType("");
    deleteHistory(discoveryCtx?.state?.id);
    setShowDeleteDialog(false);
    setProductVariants([]);
    setAICategoryTypes([]);
    setBrand("");
    setLLM("gpt-5.1");
    setAICategories([])
    setKeyPlayers([]);
    setSelectedBrandProducts([]);
    onReset();
    setMarket("");
  }



  useEffect(() => {
    if (
      !brand ||
      discoveryCtx.is_launched ||
      discoveryTransactionId
      || cancelTransaction ||
      discoveryCtx.is_resetFormState
    ) {
      return;
    }

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(() => {
      if (discoveryType === "product") {
        checkIfProductValid(brand);
      } else {
        checkIfInputValid(brand);
      }
    }, 1000);
  }, [
    brand,
    category
  ]);


  useEffect(() => {
    if (discoveryTransactionId) {
      setBrand(discoveryCtx.entity);
      setAICategories([
        {
          name: discoveryCtx.category,
          value: discoveryCtx.category,
        },
      ]);
      setAICategoryTypes([
        {
          name: discoveryCtx.categoryType,
          value: discoveryCtx.categoryType,
        },
      ]);
      setCategory(discoveryCtx.category);
      setCategoryType(discoveryCtx.categoryType);
      setMarket(discoveryCtx.market);
      setLLM(discoveryCtx.llm);
      setSelectedBrandProducts(discoveryCtx.competitors.slice(1));
    }
  }, [
    discoveryTransactionId,
    discoveryCtx.category,
    // discoveryCtx.llm,
    discoveryCtx.entity,
    discoveryCtx.market,
    discoveryCtx.competitors,
  ]);

  useEffect(() => {
    if ((cancelTransaction && !discoveryCtx.abort_launch) || discoveryCtx.is_resetFormState) {
      stopPolling();
      discoveryCtx.resetState();
      discoveryCtx.updateLanguage("en");
      setBrand(discoveryCtx.entity);
      setCategory(discoveryCtx.category);
      setCategoryType(discoveryCtx.categoryType);
      setMarket(discoveryCtx.market);
      setLLM(discoveryCtx.llm);
      setCancelTransaction(false);
      setAICategories([]);
      setKeyPlayers([]);
      setAICategoryTypes([]);
      setSelectedBrandProducts([]);
      discoveryCtx.resetFormState(false);
    }
  }, [cancelTransaction, discoveryCtx.abort_launch, discoveryCtx.is_resetFormState])

  const cancelTransactionRecord = () => {
    setCancelTransaction(true);
    resetState();
  }
  const debounceLaunch = lodash.debounce(function () {
    if ((!brand && discoveryType !== "category") || !category || !llm
      //  || !categoryType
    ) {
      toast.warn("Please fill all required fields");
      return;
    }

    if (
      discoveryType === "category" &&
      (!discoveryCtx.location ||
        !discoveryCtx.occupation ||
        discoveryCtx.attributes.length === 0)
    ) {
      toast.warn("Please fill all required fields");
      return;
    }

    const competitors = [
      {
        name: brand,
        domain: brandDomain,
        variants: productVariants,
      },
      ...(discoveryCtx?.competitors ?? [])
    ];

    onSubmit({
      brand,
      category,
      categoryType,
      market,
      llm,
      discoveryType,
      isMock,
      competitors
    });
  }, 1000);

  const moveAddManuallyToBottom = (options) => {
    const hasAddManually = options.some(
      (opt) => opt?.value === "Add Manually" || opt?.name === "Add Manually"
    );

    if (!hasAddManually) {
      return options;
    }

    const restOptions = options.filter(
      (opt) => opt?.value !== "Add Manually" && opt?.name !== "Add Manually"
    );

    return [
      ...restOptions,
      { name: "Add Manually", value: "Add Manually" },
    ];
  };

  const categoryOptions = useMemo(
    () => moveAddManuallyToBottom(aICategories),
    [aICategories]
  );
  const categoryTypeOptions = useMemo(
    () => moveAddManuallyToBottom(aICategoryTypes),
    [aICategoryTypes]
  );

  const hasFormValues =
    discoveryTransactionId ||
    brand.trim() !== "" ||
    category.trim() !== "" ||
    llm !== "gpt-5.1" ||
    market.trim() !== "" ||
    selectedBrandsProducts.length > 0;


  return (
    <div className={classes.card}>
      {discoveryCtx.type !== "category" && (
        <div className={classes.header}>
          <div className={classes.radio}>
            <RadioGroup
              disabled={discoveryCtx.loading}
              className={classes.type_radio}
              options={RADIO_OPTIONS}
              selectedvalue={discoveryType}
              onChange={handleDiscoveryTypeChange}
            />
          </div>
          <div className={classes.header_actions}>
            {warningText && <Warning text={warningText} onClose={() => setWarningText("")} />}
            <MUIButton
              variant="outlined"
              size="small"
              onClick={() => {
                setShowHistoryModal(true)
              }}
            >
              <span style={{ marginRight: '6px', fontSize: '14px' }}>🕐</span>
              View History
            </MUIButton>
          </div>
        </div>
      )}
      <div className={classes.input_group}>
        <div className={classes.input_section}>
          {discoveryType !== "category" && (
            <div className={classes.brand_input}>
              <TextInput
                disabled={discoveryCtx.loading || discoveryTransactionId}
                fullWidth
                value={brand}
                label={getEntityLabel(discoveryType)}
                placeholder={
                  discoveryType === "brand" ? ENTITY_LABELS.brandPlaceHolder : ENTITY_LABELS.productPlaceHolder
                }
                onChange={handleBrandInputChange}
              />
              {productVariants.length > 0 && (
                <ProductVariant
                  triggerId="basic-menu"
                  variants={productVariants}
                  index={0}
                  editable={!discoveryCtx.loading && !discoveryCtx.is_launched}
                >
                  <span className={classes.variant_text}>
                    {productVariants.length} variants found
                  </span>
                </ProductVariant>
              )}
              {loading && (
                <CircularProgress className={classes.loading} size={15} />
              )}
              {suggestions.length > 0 && (
                <span className={classes.hint_text}>
                  Did you mean:
                  <i
                    className={classes.hint_chip}
                    onClick={() => handleSuggestionClick(suggestions[0])}
                  >
                    {suggestions[0]}
                  </i>
                </span>
              )}
            </div>
          )}
          <div style={{ flex: 1 }}>
            <MUISelect
              disabled={discoveryCtx.loading || discoveryTransactionId}
              label={"LLM"}
              defaultValue="gpt-5.1"
              options={LLM_OPTIONS}
              optionValue={llm}
              onChange={(e) => {
                // discoveryCtx.updateLLM(e.target.value);
                resetState();
                setLLM(e.target.value);
              }}
            />
          </div>

          <div style={{ flex: 1 }}>
            <MUISelect
              disabled={discoveryCtx.loading || discoveryTransactionId}
              fullWidth
              optionValue={discoveryCtx.language}
              label={"Language"}
              options={discoveryCtx.languageList || []}
              onChange={(e) => {
                resetState();
                discoveryCtx.updateLanguage(e.target.value);
              }}
            />
          </div>

        </div>

        <div className={classes.input_section}>
          <div style={{ flex: 1 }}>
            <MUISelect
              loading={isCategorySuggestionLoading}
              disabled={discoveryCtx.loading || discoveryTransactionId}
              fullWidth
              placeholder={ENTITY_LABELS.categoryPlaceHolder}
              optionValue={category}
              label="Category"
              sx={{
                color: category ? "black" : "#979797", // Gray when placeholder is visible
              }}
              options={categoryOptions}
              onChange={(e) => {
                const value = e.target.value;
                console.log(value);
                if (value === "Add Manually") {
                  if (brand.trim().length === 0) {
                    toast.warn("Please enter brand first");
                    return;
                  }
                  setManualCategoryInput("");
                  setShowManualCategoryInput(true);
                  return;
                }
                setCategory(value);
                resetState();
              }}
            />
          </div>


          <div style={{ flex: 1 }}>
            <MUISelect
              loading={isCategoryTypeSuggestionLoading}
              disabled={discoveryCtx.loading || discoveryTransactionId}
              fullWidth
              placeholder={ENTITY_LABELS.categoryTypePlaceHolder}
              optionValue={categoryType}
              label="Category Type"
              sx={{
                color: categoryType ? "black" : "#979797", // Gray when placeholder is visible
              }}
              options={categoryTypeOptions}
              onChange={(e) => {
                const value = e.target.value;
                console.log(value);
                if (value === "Add Manually") {
                  if (brand.trim().length === 0) {
                    toast.warn("Please enter brand first");
                    return;
                  }
                  setManualCategoryTypeInput("");
                  setShowManualCategoryTypeInput(true);
                  return;
                }
                setCategoryType(value);
                resetState();
              }}
            />
          </div>

          <div style={{ flex: 1 }}>
            <TextInput
              fullWidth
              label="Market"
              disabled={discoveryCtx.loading || discoveryTransactionId}
              placeholder="e.g North America"
              value={market}
              onChange={(e) => {
                // discoveryCtx.updateMarket(e.target.value);
                setMarket(e.target.value);
                resetState();
              }}
            />
          </div>


        </div>
        {/* {discoveryCtx.type === "category" && (
            <div style={{ flex: 1 }}>
              <AttributeInput
                prefLoading={prefLoading}
                disabled={discoveryCtx.loading || discoveryCtx.is_launched}
                label="Attributes you care about"
              />
            </div>
          )} */}
        <div className={classes.input_section}>
          <div style={{ flex: 1 }}>
            <MUIMultiSelect
              loading={keyPlayersLoading}
              disabled={discoveryCtx.loading || discoveryTransactionId}
              fullWidth={true}
              optionValue={""}
              label={
                discoveryType === "category" ? "Key players " : "Competitors "
              }
              value={
                selectedBrandsProducts?.map((obj) => obj.name) || []
              }
              customWidth={classes.fullWidth}
              shouldShowValue={true}
              options={discoveryTransactionId ? [] : updatedKeyPlayers}
              allowSettingPrimary={false}
              showAddManuallyOption={true}
              onChange={(e) => {
                const values = e;
                const hasAddManually = values.includes("addManually");
                if (hasAddManually) {

                  if (category.trim().length === 0) {
                    toast.warn("Please enter category first");
                    return;
                  }

                  setShowManualKeyPlayerInput(true);
                  return;
                }

                handleProductBrandSelection(values, updatedKeyPlayers);
              }}
            />
            {discoveryCtx.competitors.length < 1 &&
              category &&
              updatedKeyPlayers &&
              updatedKeyPlayers.length > 0 && (
                <Typography
                  color="textDisabled"
                  variant="caption"
                  sx={{ fontSize: "8px" }}
                >
                  Select{" "}
                  {discoveryType === "category" ? "key players " : "competitors "}
                  <Typography
                    color="error"
                    variant="caption"
                    sx={{ fontSize: "8px" }}
                  >
                    ({discoveryType === "category" ? "upto 4" : "minimum 1, upto 5"})
                  </Typography>
                </Typography>
              )}
          </div>

          {/* <div style={{ flex: 1 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isMock}
                  onChange={(e) => setIsMock(e.target.checked)}
                  disabled={discoveryCtx.loading || discoveryCtx.is_launched}
                />
              }
              label="isMock"
            />
          </div> */}

        </div>
        <div className={classes.action_buttons}>
          {!discoveryCtx?.state?.id && (
            <MUIButton
              variant="contained"
              color={discoveryCtx.loading ? "error" : "primary"}
              disabled={
                loading ||
                !category ||
                // !categoryType ||
                discoveryCtx.is_launched ||
                (discoveryType !== "category" && !brand) ||
                !hasRequiredCompetitors
              }
              onClick={debounceLaunch}
            >
              Launch
            </MUIButton>
          )}
          {discoveryCtx?.state?.id && (
            <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
              {discoveryCtx.state.transactionStatus !== "COMPLETED" && (
                <MUIButton color="error" onClick={() => setShowDeleteDialog(true)}>
                  Cancel
                </MUIButton>
              )}
            </div>
          )}
          <MUIButton
            variant="outlined"
            color="primary"
            onClick={cancelTransactionRecord}
            disabled={!hasFormValues}
          >
            Start New
          </MUIButton>
        </div>
      </div>
      <History
        open={showHistoryModal}
        onClose={() => setShowHistoryModal(false)}
        filter={discoveryCtx.type}
        setCancelTransaction={setCancelTransaction}
        startPolling={startPolling}
        stopPolling={stopPolling}
        isHistoryRefresh={isHistoryRefresh}
        setIsHistoryRefresh={setIsHistoryRefresh}
        page={page}
        setPage={setPage}
      />
      {showManualKeyPlayerInput && (
        <UserKeyPlayer
          open={showManualKeyPlayerInput}
          category={category}
          discoveryType={discoveryType}
          handleClose={() => setShowManualKeyPlayerInput(false)}
          handleConfirm={(val, domain = "example.com", variants) => {
            handleProductBrandSelection({
              id: val,
              name: val,
              domain,
              value: val,
              variants,
            });
            setShowManualKeyPlayerInput(false);
          }}
        />
      )}

      {showManualCategoryInput && (
        <Modal
          title="Add Category"
          open={true}
          showActions
          handleClose={() => setShowManualCategoryInput(false)}
          handleConfirm={() => {
            console.log("Confirm: " + manualCategoryInput);
            setAICategories((prev) => [
              ...prev,
              {
                name: manualCategoryInput,
                value: manualCategoryInput,
              },
            ]);
            resetState();
            setCategory(manualCategoryInput);
            setShowManualCategoryInput(false);
          }}
          confirmBtnDisabled={!manualCategoryInput}
        >
          <TextInput
            className={classes.input}
            fullWidth
            type="text"
            value={manualCategoryInput}
            onChange={(e) => setManualCategoryInput(e.target.value)}
            placeholder={"Enter category"}
          />
        </Modal>
      )}

      {showManualCategoryTypeInput && (
        <Modal
          title="Add Category Type"
          open={true}
          showActions
          handleClose={() => setShowManualCategoryTypeInput(false)}
          handleConfirm={() => {
            console.log("Confirm: " + manualCategoryTypeInput);
            setAICategoryTypes((prev) => [
              ...prev,
              {
                name: manualCategoryTypeInput,
                value: manualCategoryTypeInput,
              },
            ]);
            resetState();
            setCategoryType(manualCategoryTypeInput);
            setShowManualCategoryTypeInput(false);
          }}
          confirmBtnDisabled={!manualCategoryTypeInput}
        >
          <TextInput
            className={classes.input}
            fullWidth
            type="text"
            value={manualCategoryTypeInput}
            onChange={(e) => setManualCategoryTypeInput(e.target.value)}
            placeholder={"Enter category Type"}
          />
        </Modal>
      )}

      {discoveryCtx?.state?.id && (
        <Modal
          handleClose={() => setShowDeleteDialog(false)}
          handleConfirm={deleteTransaction}
          open={showDeleteDialog}
          title="Delete History"
          showActions
          confirmBtnText="Delete"
          confirmBtnColor="error"
        >
          <div className={classes.contentText}>
            Do you want to delete this item - {discoveryCtx?.entity}?
          </div>
        </Modal>
      )}
      <ToastContainer />
    </div>
  );
}
